import classNames from 'classnames';

import React, { useState, useEffect, useRef, useMemo, Fragment } from 'react'

// Partials
import Link from '../link'
import Icon from '../icon';

const useStatusState = (loading) => {
	let loadingTimeout = useRef(false);

	const [active, setActive] = useState(loading);
	const [show, setShow] = useState(loading);

	useEffect(() => {
		if (loadingTimeout.current !== false) {
			clearTimeout(loadingTimeout.current);
			loadingTimeout.current = false;
		}

		if (loading) {
			setActive(true);
			loadingTimeout.current = setTimeout(function () {
				setShow(true);
			}, 30);
		}
		else {
			setShow(false);
			loadingTimeout.current = setTimeout(function () {
				setActive(false);
			}, 200);
		}
	}, [loading]);

	return [active, show];
}

export const Btn = React.forwardRef(({ className: classNameProp, wrapText, tag, icon, afterIcon, loading, status: propStatus, children, loadingIcon, ...rawProps }, ref) => {

	const status = useMemo(() => {
		return loading ? 'loading' : propStatus;
	}, [loading, propStatus]);

	const [statusActive, statusShow] = useStatusState(!!status);

	const { Tag, WrapElem, iconOnly, wrapProps, ...computedProps } = useMemo(() => {
		const computedProps = {
			Tag: tag,
			children: children,
			iconOnly: false,
			WrapElem: Fragment,
			wrapProps: { }
		}

		if(tag === 'link') {
			computedProps.Tag = Link;
		}

		if(ref) {
			computedProps.ref = ref;
		}

		if(icon && !afterIcon && !children) {
			computedProps.iconOnly = true;
		}

		if(wrapText) {
			computedProps.WrapElem = 'span';
			computedProps.wrapProps = {
				className: 'btn-text'
			}
		}

		return computedProps;
	}, [classNameProp, children, tag, ref, icon, afterIcon, wrapText])

	const className = useMemo(() => ( classNames('btn', classNameProp, (status ? `status-${status}`: undefined), { 'icon-only': iconOnly, 'show-status': statusShow }) ), [classNameProp, iconOnly, statusShow, status])

	return (
		<Tag {...{
			...computedProps,
			...rawProps,
			className,
		}}>
			{(statusActive) &&
				<span className="btn-statuswrap">
					<>
						{status === 'loading' ?
							<Icon className={classNames('btn-status', 'loading')} name={loadingIcon} />
							:
							<Icon name={status === 'complete' ? 'check' : status} className="btn-status" />
						}
					</>
				</span>
			}
			<div className="btn-content">
				{icon &&
					<>
						{typeof icon === 'string' ?
							<Icon className={classNames('btn-icon', { pre: !iconOnly })} name={icon} />
							:
							<span className={classNames('btn-iconwrap', { pre: !iconOnly })}>{icon}</span>
						}
					</>
				}
				<WrapElem {...wrapProps}>
					{children}
				</WrapElem>
				{afterIcon &&
					<>
						{typeof afterIcon === 'string' ?
							<Icon className={classNames('btn-icon', 'post')} name={afterIcon} />
							:
							<span className={classNames('btn-iconwrap', 'post')}>{afterIcon}</span>
						}
					</>
				}
			</div>
		</Tag>
	)
})

Btn.defaultProps = {
	className: '',
	tag: 'button',
	children: false,
	status: false,
	wrapText: false,
	icon: false,
	afterIcon: false,
	type: "button",
	loadingIcon: "spinner",
}